const RentalManagersStyles = {
  container: {
    backgroundColor: '#f4f4f9',
    padding: '80px 0',
  },
};

export default RentalManagersStyles;
